import css from "./OfficeHourSchedulingOptions.scss";
import prefCss from "../PreferencesSection.scss";
import LabelledRadioOption from "common/LabelledRadioOption";
import React from "react";
import Icon from "SF/MaterialIcon";
import PropTypes from "prop-types";
import { isPositiveInteger } from "utils/text";
import { getWord } from "utils/tenant";
import classnames from "classnames";

const HoursBefore = ({isSelected, onHoursInput, onRadioSelect, hoursValue}) => {
    const errorMessage = () => {
        if(isSelected && !isPositiveInteger(hoursValue)) {
            return (
                <div className={css['hours-before-error']}>
                    <Icon icon="error" aria-hidden={true} />Hour(s) must be a whole number that is 0 or greater
                </div>
            );
        }
        return null;
    };

    return (
        <div className={classnames(css['hours-before'],  {[prefCss.error]: isSelected && !isPositiveInteger(hoursValue)})}>
            <LabelledRadioOption isChecked={isSelected}
                                 labelId="hoursBefore"
                                 radioGroupName="schedulingOptions"
                                 onRadioSelect={onRadioSelect}
                                 label={<><span className={css['emphasized-underline-text']}>Hour(s) before</span>
                                       {` the ${getWord('officeHours', true)}:`}</>} />
            <input type="number"
                   aria-labelledby="hoursBefore"
                   min="0"
                   value={hoursValue}
                   disabled={!isSelected}
                   onChange={(e) => onHoursInput(e.target.value)} />
            {errorMessage()}
        </div>
    );
}

HoursBefore.propTypes = {
    hoursValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    isSelected: PropTypes.bool.isRequired,
    onHoursInput: PropTypes.func,
    onRadioSelect: PropTypes.func
};

export default HoursBefore;
